import * as React from 'react';

function SearchIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      className="search-icon_svg__icon"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      aria-hidden="true"
      fill="currentColor"
      {...props}
    >
      <path d="M15.0252 13.8478L18.5943 17.4162L17.4152 18.5953L13.8469 15.0262C12.5191 16.0905 10.8677 16.6694 9.16602 16.667C5.02602 16.667 1.66602 13.307 1.66602 9.16699C1.66602 5.02699 5.02602 1.66699 9.16602 1.66699C13.306 1.66699 16.666 5.02699 16.666 9.16699C16.6684 10.8687 16.0895 12.5201 15.0252 13.8478ZM13.3535 13.2295C14.4111 12.1419 15.0017 10.684 14.9993 9.16699C14.9993 5.94366 12.3885 3.33366 9.16602 3.33366C5.94268 3.33366 3.33268 5.94366 3.33268 9.16699C3.33268 12.3895 5.94268 15.0003 9.16602 15.0003C10.683 15.0027 12.1409 14.4121 13.2285 13.3545L13.3535 13.2295Z" />
    </svg>
  );
}
// function SearchIcon(props: React.SVGProps<SVGSVGElement>) {
//   return (
//     <svg
//       className="search-icon_svg__icon"
//       viewBox="0 0 1024 1024"
//       xmlns="http://www.w3.org/2000/svg"
//       width="1em"
//       height="1em"
//       aria-hidden="true"
//       fill="currentColor"
//       {...props}
//     >
//       <defs>
//         <style />
//       </defs>
//       <path d="M416 192c121.6 0 224 102.4 224 224S537.6 640 416 640 192 537.6 192 416s102.4-224 224-224m0-64c-160 0-288 128-288 288s128 288 288 288 288-128 288-288-128-288-288-288z" />
//       <path d="M832 864c-6.4 0-19.2 0-25.6-6.4l-192-192c-12.8-12.8-12.8-32 0-44.8s32-12.8 44.8 0l192 192c12.8 12.8 12.8 32 0 44.8 0 6.4-12.8 6.4-19.2 6.4z" />
//     </svg>
//   );
// }

export default SearchIcon;
